import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import './css/PictureBox.css';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

export function PictureBox({ images, deleteImage, updateOrder }) {
    const [dragging, setDragging] = useState(false);

    function onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        const newImages = reorder(
            images,
            result.source.index,
            result.destination.index
        );
        updateOrder(newImages);
    }

    return (
        <div className="picture-box">
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable" direction="horizontal">
                    {(provided, snapshot) => (
                        <div className="picture-sequence drag-sort-enable" id="images-container"
                            ref={provided.innerRef}
                            {...provided.droppableProps}>
                            {images.length ? <div className="stoper"><div className="line-1"></div></div> : <></>}

                            {images.map((image, i) => {
                                return (
                                    <Draggable key={i} draggableId={`item-${i}`} index={i}>
                                        {(provided, snapshot) => {
                                            let loadingId = null;
                                            let loading = false;
                                            return (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    className="picture-preview" id={`picture-${i}`} index={i} key={image.name}
                                                    onMouseEnter={() => { document.getElementById(`image-container-${i}`).style.filter = "blur(4px)"; }}
                                                    onMouseDown={() => { setDragging(true) }}
                                                    onMouseLeave={() => {
                                                        setDragging(false);
                                                        document.getElementById(`image-container-${i}`).style.filter = "";
                                                    }}
                                                    onMouseUp={() => { setDragging(false) }}
                                                >
                                                    <div className="picture-preview-hover" id="picture-${index}-hover">
                                                        <div className="delete-icon"
                                                            onClick={() => { deleteImage(i) }}
                                                            onMouseEnter={() => { document.getElementById(`picture-delete-icon-${i}`).setAttribute('src', 'icons/delete-2-red.svg') }}
                                                            onMouseDown={() => { document.getElementById(`picture-delete-icon-${i}`).setAttribute('src', 'icons/delete-2-white.svg') }}
                                                            onMouseUp={() => { document.getElementById(`picture-delete-icon-${i}`).setAttribute('src', 'icons/delete-2.svg') }}
                                                            onMouseLeave={() => { document.getElementById(`picture-delete-icon-${i}`).setAttribute('src', 'icons/delete-2.svg') }}>
                                                            <img src="icons/delete-2.svg" id={`picture-delete-icon-${i}`} className="component-1" />
                                                        </div>
                                                        <div className={dragging ? "drag-icon drag-icon-dragging" : "drag-icon"}>
                                                            <div className="component-1">
                                                                <img src={dragging ? "icons/drag-white.svg" : "icons/drag.svg"} id="drag-icon-${index}" draggable="false" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div id={`image-container-${i}`} className="image-container">
                                                        <img className="image" id={`image-${i}`}
                                                            src={`${image.imageSrc}`}
                                                            onError={({ currentTarget }) => {
                                                                clearTimeout(loadingId);
                                                                loadingId = setTimeout(() => {
                                                                    currentTarget.onerror = null; // prevents looping
                                                                    currentTarget.src = "icons/error.svg";
                                                                }, 10000);
                                                                currentTarget.src = "icons/loading.gif";
                                                                currentTarget.onload = () => {
                                                                    if (currentTarget.src != `/icons/loading.gif`)
                                                                        clearTimeout(loadingId);
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            )
                                        }}
                                    </Draggable>
                                )
                            })}
                            {provided.placeholder}
                            {images.length ? <div className="stoper"><div className="line-1"></div></div> : <></>}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </div>
    );
}
